var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useCallback, useEffect, useState } from "react";
import { colorTheme } from "../config";
import { LinkState, NodeState } from "../models";
import { getRandomGraph } from "../prim/default.config";
var treeCounter = 0;
var Graph = /** @class */ (function () {
    function Graph(nodes, links) {
        this.nodes = nodes;
        this.links = links;
    }
    Graph.prototype.getNode = function (id) {
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].id === id) {
                return this.nodes[i];
            }
        }
        return null;
    };
    Graph.prototype.getNodes = function (comparator) {
        return this.nodes.filter(comparator);
    };
    Graph.prototype.getComponentData = function () {
        var componentData = { nodes: [], links: [] };
        for (var i = 0; i < this.nodes.length; i++) {
            var node = this.nodes[i];
            componentData.nodes.push({
                x: node.x,
                y: node.y - 50,
                id: node.id,
                label: node.id,
                color: node.state === NodeState.VISITED
                    ? colorTheme.primary.DEFAULT
                    : colorTheme.primary.lightest,
            });
        }
        for (var i = 0; i < this.links.length; i++) {
            var link = this.links[i];
            var color = colorTheme.primary.lightest;
            switch (link.state) {
                case LinkState.POSSIBLE:
                    color = colorTheme.primary.darker;
                    break;
                case LinkState.VISITED:
                    color = colorTheme.primary.DEFAULT;
                    break;
                case LinkState.ERROR:
                    color = colorTheme.error;
                    break;
            }
            link.connection.sort();
            componentData.links.push({
                source: link.connection[0],
                target: link.connection[1],
                label: "" + link.weight,
                color: color,
            });
        }
        return componentData;
    };
    Graph.prototype.getVisitedNodes = function () {
        var visitedNodes = [];
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].state === NodeState.VISITED) {
                visitedNodes.push(this.nodes[i]);
            }
        }
        return visitedNodes;
    };
    Graph.prototype.getConnectedLinks = function (visitedNodes) {
        var res = [];
        for (var i = 0; i < this.links.length; i++) {
            var link = this.links[i];
            for (var j = 0; j < visitedNodes.length; j++) {
                var node = visitedNodes[j];
                if (link.connection.includes(node.id)) {
                    res.push(link);
                    break;
                }
            }
        }
        return res;
    };
    Graph.prototype.refresh = function () {
        for (var li = 0; li < this.links.length; li++) {
            if (this.links[li].state !== LinkState.VISITED) {
                this.links[li].state = LinkState.DEFAULT;
            }
        }
        for (var ni = 0; ni < this.nodes.length; ni++) {
            if (this.nodes[ni].state !== NodeState.VISITED) {
                this.nodes[ni].state = NodeState.DEFAULT;
            }
        }
    };
    Graph.prototype.visitLink = function (link) {
        link.state = LinkState.VISITED;
        var nodeLeft = this.getNode(link.connection[0]);
        var nodeRight = this.getNode(link.connection[1]);
        var treeLeft = "" + nodeLeft.treeId;
        var treeRight = "" + nodeRight.treeId;
        console.log("nodes (before):", this.nodes);
        if (nodeLeft.state === NodeState.VISITED &&
            nodeRight.state === NodeState.VISITED) {
            console.log("both visited", treeLeft, treeRight);
            var treeId_1 = "tree" + treeCounter;
            treeCounter++;
            this.nodes.forEach(function (node) {
                if (node.treeId == treeLeft || node.treeId == treeRight) {
                    node.treeId = treeId_1;
                }
                else {
                    console.log("no match for ", node.treeId, nodeLeft.treeId, nodeRight.treeId);
                }
            });
        }
        else if (nodeLeft.state === NodeState.VISITED ||
            nodeRight.state === NodeState.VISITED) {
            console.log("one visited");
            var treeId = nodeRight.treeId || nodeLeft.treeId;
            nodeRight.treeId = treeId;
            nodeLeft.treeId = treeId;
        }
        else {
            console.log("none visited");
            var treeId = "tree" + treeCounter;
            treeCounter++;
            nodeRight.treeId = treeId;
            nodeLeft.treeId = treeId;
        }
        this.getNode(link.connection[0]).state = NodeState.VISITED;
        this.getNode(link.connection[1]).state = NodeState.VISITED;
        console.log("nodes (after):", this.nodes);
    };
    Graph.prototype.getClickedLink = function (source, target) {
        return this.links[this.links.findIndex(function (link) {
            return link.connection.includes(source) && link.connection.includes(target);
        })];
    };
    Graph.prototype.getErrorMessageFor = function (link) {
        if (link.state === LinkState.VISITED) {
            return "Link already visited";
        }
        var nodeLeft = this.getNode(link.connection[0]);
        var nodeRight = this.getNode(link.connection[1]);
        if (nodeLeft.state !== NodeState.VISITED ||
            nodeRight.state !== NodeState.VISITED) {
            return null;
        }
        if (nodeLeft.treeId === nodeRight.treeId) {
            return "Can't connect two already connected subtrees";
        }
        return null;
    };
    Graph.prototype.isOneTree = function () {
        var visitedLinks = this.links.filter(function (link) { return link.state === LinkState.VISITED; });
        if (visitedLinks.length === this.nodes.length - 1) {
            return true;
        }
        return false;
    };
    return Graph;
}());
export function useKruskal() {
    var _a = useState(new (Graph.bind.apply(Graph, __spreadArray([void 0], getRandomGraph())))()), stateGraph = _a[0], setGraph = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), solved = _c[0], setSolved = _c[1];
    var _d = useState(3), chancesLeft = _d[0], setChancesLeft = _d[1];
    var _e = useState(false), gameOver = _e[0], setGameOver = _e[1];
    useEffect(function () {
        if (chancesLeft === 0) {
            var graph = new Graph(stateGraph.nodes, stateGraph.links);
            graph.links.forEach(function (link) { return link.state === LinkState.ERROR; });
            setGraph(graph);
            setGameOver(true);
        }
    }, [chancesLeft]);
    var clickLink = useCallback(function (source, target) {
        console.log("CLICK");
        if (gameOver) {
            alert("GAME OVER. RESET");
            return;
        }
        var graph = new Graph(stateGraph.nodes, stateGraph.links);
        console.log(graph);
        //remove errors and highlights
        graph.refresh();
        var possibleLinks = graph.links.filter(function (link) {
            var errorMessage = graph.getErrorMessageFor(link);
            if (errorMessage) {
                return false;
            }
            return true;
        });
        var sortedLinks = possibleLinks.sort(function (a, b) { return a.weight - b.weight; });
        var minimumLinks = sortedLinks.filter(function (link) {
            return link.weight <= sortedLinks[0].weight;
        });
        var clickedLink = graph.getClickedLink(source, target);
        var errorMessage = graph.getErrorMessageFor(clickedLink);
        if (errorMessage) {
            setError(errorMessage);
            setChancesLeft(chancesLeft - 1);
            return;
        }
        for (var i = 0; i < minimumLinks.length; i++) {
            var curLink = minimumLinks[i];
            if (curLink.connection.includes(source) &&
                curLink.connection.includes(target)) {
                graph.visitLink(curLink);
                var visitedNodes = graph.getVisitedNodes();
                if (visitedNodes.length === graph.nodes.length && graph.isOneTree()) {
                    setSolved(true);
                }
                setError(null);
                setGraph(graph);
                return;
            }
        }
        clickedLink.state = LinkState.ERROR;
        setError("The clicked link does not have the smallest possible weight");
        setChancesLeft(chancesLeft - 1);
        setGraph(graph);
        return;
    }, [error, chancesLeft, gameOver, stateGraph]);
    var reset = useCallback(function () {
        var graph = new (Graph.bind.apply(Graph, __spreadArray([void 0], getRandomGraph())))();
        setGraph(graph);
        setSolved(false);
        setError(null);
        setChancesLeft(3);
        setGameOver(false);
    }, [stateGraph, setGraph]);
    return [stateGraph, clickLink, reset, error, solved, chancesLeft, gameOver];
}
